import React, { Component } from "react";
import SecureLocalStorage from "secure-ls";
import queryString from "query-string";
import axios from "axios";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import ReferralHash from "../../../common/referral-hash";
// import ReactGA from "react-ga";

import {
  incrementReferralAction,
  refreshTokenAction,
  restoreAuthenticationAction,
  signOutAction,
} from "features/application/authentication/redux/actions";

import {
  deleteDataAction,
  getUserDataAction,
  incrementStepAction,
} from "features/application/form/redux/actions";

import { sendAnalyticEvent } from "../requests/send-analytic-event";

import ApplicationView from "screens/application/component/view";
import { incrementReferral } from "../../new/requests/increment-referral";

const mapStateToProps = (state) => ({
  responseCodes: Object.assign(
    {},
    state.authenticationReducer.responseCodes,
    state.formReducer.responseCodes
  ),
  errorCodes: Object.assign(
    {},
    state.authenticationReducer.errorCodes,
    state.formReducer.errorCodes
  ),
  errorFields: state.formReducer.errorFields,
  token: state.authenticationReducer.token,
  userData: state.formReducer.userData,
  memberships: state.formReducer.memberships,
});

const mapDispatchToProps = (dispatch) => ({
  restoreAuthentication: (token) =>
    dispatch(restoreAuthenticationAction(token)),
  refreshToken: (token) => dispatch(refreshTokenAction(token)),
  getUserData: (token) => dispatch(getUserDataAction(token)),
  incrementStep: (id) => dispatch(incrementStepAction(id)),
  deleteData: () => dispatch(deleteDataAction()),
  incrementReferral: (hash) => dispatch(incrementReferralAction(hash)),
  signOut: () => dispatch(signOutAction()),
});

class Application extends Component {
  constructor(props) {
    super(props);

    this.secureLocalStorage = new SecureLocalStorage({
      encodingType: "des",
      isCompression: false,
      encryptionSecret: "parlor-social-club",
    });

    this.setAuthentication = this.setAuthentication.bind(this);
    this.signOut = this.signOut.bind(this);

    const {
      location: { search },
    } = props;

    let hash = null;

    if (search) {
      hash = queryString.parse(search.replace("+", "%2B")).referral_hash;

      if (hash) {
        localStorage.setItem("referral_hash", hash);
        incrementReferral(hash);
      }
    }

    if (!hash) {
      hash = localStorage.getItem("referral_hash");
    }

    ReferralHash.hash = hash;

    axios({
      method: "POST",
      url: "/api/v2/link-url",
      data: { url: window.location.href },
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userData?.member_id !== this.props?.userData?.member_id) {
      window.dataLayer.push({
        event: "user_login",
        userId: this.props.userData?.member_id,
      });
    }
  }

  componentDidMount() {
    const {
      restoreAuthentication,
      refreshToken,
      match: {
        params: { currentStep },
      },
      history,
    } = this.props;

    const token = this.secureLocalStorage.get("token").data;
    const currentTime = new Date().getTime();

    if (token) {
      if (
        currentStep === "reset-password" ||
        currentStep === "create-password"
      ) {
        this.signOut();
      } else if (token.expiresIn + currentTime <= currentTime) {
        refreshToken(token);
      } else {
        restoreAuthentication(token);
      }
    } else if (
      currentStep !== "sign-up" &&
      currentStep !== "sign-in" &&
      currentStep !== "referral" &&
      currentStep !== "reset-password" &&
      currentStep !== "create-password" &&
      currentStep !== "change-email"
    ) {
      history.replace(
        "/application/sign-in" +
          (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
      );
    }
  }

  getCookie(name) {
    let cookies = `; ${document.cookie}`;
    let parts = cookies.split(`; ${name}=`);

    return parts.length === 2 && parts.pop().split(";").shift();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      responseCodes,
      errorCodes,
      match: {
        params: { currentStep },
      },
      history,
      token,
      userData,
      memberships,
      incrementStep,
    } = this.props;

    !nextProps.token &&
      nextProps.token !== token &&
      history.replace(
        "/application/sign-in" +
          (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
      );

    nextProps.token &&
      nextProps.token !== token &&
      this.setAuthentication(nextProps.token);

    if (
      memberships &&
      nextProps.userData &&
      (JSON.stringify(nextProps.userData) !== JSON.stringify(userData) ||
        currentStep === "sign-up")
    ) {
      if (
        nextProps.userData.use_payment &&
        nextProps.userData.plan_id !== null &&
        !memberships.find(
          (membership) => membership.id === nextProps.userData.plan_id
        ) &&
        !nextProps.userData.is_referred
      ) {
        history.replace(
          "/application/memberships" +
            (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
        );
      }

      if (
        currentStep !== "reasons-to-join" &&
        currentStep !== "details" &&
        currentStep !== "interests" &&
        currentStep !== "about" &&
        currentStep !== "memberships" &&
        currentStep !== "payment" &&
        currentStep !== "email-confirmation" &&
        currentStep !== "congrats" &&
        currentStep !== "congratulations" &&
        currentStep !== "download"
      ) {
        switch (nextProps.userData.current_step) {
          case null:
          case 0:
            history.replace(
              "/application/reasons-to-join" +
                (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
            );
            break;
          case 1:
            history.replace(
              "/application/details" +
                (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
            );
            break;
          case 2:
            history.replace(
              "/application/interests" +
                (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
            );
            break;
          case 3:
            history.replace(
              "/application/about" +
                (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
            );
            break;
          case 4:
            if (nextProps.userData.use_payment) {
              history.replace(
                "/application/memberships" +
                  (ReferralHash.hash
                    ? "?referral_hash=" + ReferralHash.hash
                    : "")
              );
            } else {
              if (
                nextProps.userData.is_verified_email &&
                nextProps.userData.is_terms_accepted
              ) {
                if (nextProps.userData.is_active) {
                  history.replace(
                    "/application/download" +
                      (ReferralHash.hash
                        ? "?referral_hash=" + ReferralHash.hash
                        : "")
                  );
                } else {
                  if (
                    nextProps.userData.use_payment &&
                    memberships.find(
                      (membership) =>
                        membership.id === nextProps.userData.plan_id
                    ) &&
                    !memberships.find(
                      (membership) =>
                        membership.id === nextProps.userData.plan_id
                    ).is_free
                  ) {
                    history.replace(
                      "/application/congratulations" +
                        (ReferralHash.hash
                          ? "?referral_hash=" + ReferralHash.hash
                          : "")
                    );
                  } else {
                    history.replace(
                      "/application/congrats" +
                        (ReferralHash.hash
                          ? "?referral_hash=" + ReferralHash.hash
                          : "")
                    );
                  }
                }
              } else {
                history.replace(
                  "/application/email-confirmation" +
                    (ReferralHash.hash
                      ? "?referral_hash=" + ReferralHash.hash
                      : "")
                );
              }
            }
            break;
          case 5:
            if (
              !nextProps.userData.is_referred &&
              nextProps.userData.use_payment &&
              memberships.find(
                (membership) => membership.id === nextProps.userData.plan_id
              ) &&
              !memberships.find(
                (membership) => membership.id === nextProps.userData.plan_id
              ).is_free
            ) {
              history.replace(
                "/application/payment" +
                  (ReferralHash.hash
                    ? "?referral_hash=" + ReferralHash.hash
                    : "")
              );
            } else if (
              nextProps.userData.is_referred ||
              !nextProps.userData.use_payment ||
              (memberships.find(
                (membership) => membership.id === nextProps.userData.plan_id
              ) &&
                memberships.find(
                  (membership) => membership.id === nextProps.userData.plan_id
                ).is_free)
            ) {
              if (
                nextProps.userData.is_verified_email &&
                nextProps.userData.is_terms_accepted
              ) {
                if (nextProps.userData.is_active) {
                  history.replace(
                    "/application/download" +
                      (ReferralHash.hash
                        ? "?referral_hash=" + ReferralHash.hash
                        : "")
                  );
                } else {
                  if (
                    nextProps.userData.use_payment &&
                    memberships.find(
                      (membership) =>
                        membership.id === nextProps.userData.plan_id
                    ) &&
                    !memberships.find(
                      (membership) =>
                        membership.id === nextProps.userData.plan_id
                    ).is_free
                  ) {
                    history.replace(
                      "/application/congratulations" +
                        (ReferralHash.hash
                          ? "?referral_hash=" + ReferralHash.hash
                          : "")
                    );
                  } else {
                    history.replace(
                      "/application/congrats" +
                        (ReferralHash.hash
                          ? "?referral_hash=" + ReferralHash.hash
                          : "")
                    );
                  }
                }
              } else {
                history.replace(
                  "/application/email-confirmation" +
                    (ReferralHash.hash
                      ? "?referral_hash=" + ReferralHash.hash
                      : "")
                );
              }
            }
            break;
          case 6:
            if (
              nextProps.userData.is_verified_email &&
              nextProps.userData.is_terms_accepted
            ) {
              if (nextProps.userData.is_active) {
                history.replace(
                  "/application/download" +
                    (ReferralHash.hash
                      ? "?referral_hash=" + ReferralHash.hash
                      : "")
                );
              } else {
                if (
                  nextProps.userData.use_payment &&
                  memberships.find(
                    (membership) => membership.id === nextProps.userData.plan_id
                  ) &&
                  !memberships.find(
                    (membership) => membership.id === nextProps.userData.plan_id
                  ).is_free
                ) {
                  history.replace(
                    "/application/congratulations" +
                      (ReferralHash.hash
                        ? "?referral_hash=" + ReferralHash.hash
                        : "")
                  );
                } else {
                  history.replace(
                    "/application/congrats" +
                      (ReferralHash.hash
                        ? "?referral_hash=" + ReferralHash.hash
                        : "")
                  );
                }
              }
            } else {
              history.replace(
                "/application/email-confirmation" +
                  (ReferralHash.hash
                    ? "?referral_hash=" + ReferralHash.hash
                    : "")
              );
            }
            break;
          case 7:
            if (nextProps.userData.is_active) {
              history.replace(
                "/application/download" +
                  (ReferralHash.hash
                    ? "?referral_hash=" + ReferralHash.hash
                    : "")
              );
            } else {
              if (
                nextProps.userData.use_payment &&
                memberships.find(
                  (membership) => membership.id === nextProps.userData.plan_id
                ) &&
                !memberships.find(
                  (membership) => membership.id === nextProps.userData.plan_id
                ).is_free
              ) {
                history.replace(
                  "/application/congratulations" +
                    (ReferralHash.hash
                      ? "?referral_hash=" + ReferralHash.hash
                      : "")
                );
              } else {
                history.replace(
                  "/application/congrats" +
                    (ReferralHash.hash
                      ? "?referral_hash=" + ReferralHash.hash
                      : "")
                );
              }
            }
            break;
        }
      } else {
        if (nextProps.userData.is_active) {
          history.replace(
            "/application/download" +
              (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
          );
        } else if (nextProps.userData.is_completed) {
          if (
            nextProps.userData.use_payment &&
            memberships.find(
              (membership) => membership.id === nextProps.userData.plan_id
            ) &&
            !memberships.find(
              (membership) => membership.id === nextProps.userData.plan_id
            ).is_free
          ) {
            history.replace(
              "/application/congratulations" +
                (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
            );
          } else {
            history.replace(
              "/application/congrats" +
                (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
            );
          }
        } else {
          switch (currentStep) {
            case "details":
              if (nextProps.userData.current_step < 1) {
                if (history.length > 1) {
                  sendAnalyticEvent(nextProps.userData.current_step);
                  console.log("debug");
                  history.replace(
                    "/application/reasons-to-join" +
                      (ReferralHash.hash
                        ? "?referral_hash=" + ReferralHash.hash
                        : "")
                  );
                } else {
                  history.replace(
                    "/application/sign-in" +
                      (ReferralHash.hash
                        ? "?referral_hash=" + ReferralHash.hash
                        : "")
                  );
                }
              }
              break;
            case "interests":
              if (nextProps.userData.current_step < 2) {
                if (history.length > 1) {
                  sendAnalyticEvent(nextProps.userData.current_step);
                  console.log("debug");

                  history.replace(
                    "/application/reasons-to-join" +
                      (ReferralHash.hash
                        ? "?referral_hash=" + ReferralHash.hash
                        : "")
                  );
                } else {
                  history.replace(
                    "/application/sign-in" +
                      (ReferralHash.hash
                        ? "?referral_hash=" + ReferralHash.hash
                        : "")
                  );
                }
              }
              break;
            case "about":
              if (nextProps.userData.current_step < 3) {
                if (history.length > 1) {
                  sendAnalyticEvent(nextProps.userData.current_step);
                  console.log("debug");

                  history.replace(
                    "/application/reasons-to-join" +
                      (ReferralHash.hash
                        ? "?referral_hash=" + ReferralHash.hash
                        : "")
                  );
                } else {
                  history.replace(
                    "/application/sign-in" +
                      (ReferralHash.hash
                        ? "?referral_hash=" + ReferralHash.hash
                        : "")
                  );
                }
              }
              break;
            case "memberships":
              if (
                nextProps.userData.current_step < 4 ||
                nextProps.userData.is_referred ||
                !nextProps.userData.use_payment
              ) {
                if (history.length > 1) {
                  sendAnalyticEvent(nextProps.userData.current_step);
                  console.log("debug");

                  history.replace(
                    "/application/reasons-to-join" +
                      (ReferralHash.hash
                        ? "?referral_hash=" + ReferralHash.hash
                        : "")
                  );
                } else {
                  history.replace(
                    "/application/sign-in" +
                      (ReferralHash.hash
                        ? "?referral_hash=" + ReferralHash.hash
                        : "")
                  );
                }
              }
              break;
            case "payment":
              if (
                nextProps.userData.current_step < 5 ||
                nextProps.userData.is_referred ||
                !nextProps.userData.use_payment ||
                (memberships.find(
                  (membership) => membership.id === nextProps.userData.plan_id
                ) &&
                  memberships.find(
                    (membership) => membership.id === nextProps.userData.plan_id
                  ).is_free)
              ) {
                if (history.length > 1) {
                  sendAnalyticEvent(nextProps.userData.current_step);
                  console.log("debug");

                  history.replace(
                    "/application/reasons-to-join" +
                      (ReferralHash.hash
                        ? "?referral_hash=" + ReferralHash.hash
                        : "")
                  );
                } else {
                  history.replace(
                    "/application/sign-in" +
                      (ReferralHash.hash
                        ? "?referral_hash=" + ReferralHash.hash
                        : "")
                  );
                }
              } else {
                fbq("track", "InitiateCheckout"); // eslint-disable-line
              }
              break;
            case "email-confirmation":
              if (
                (nextProps.userData.is_verified_email &&
                  nextProps.userData.is_terms_accepted) ||
                (nextProps.userData.current_step < 5 &&
                  (nextProps.userData.is_referred ||
                    (memberships.find(
                      (membership) =>
                        membership.id === nextProps.userData.plan_id
                    ) &&
                      memberships.find(
                        (membership) =>
                          membership.id === nextProps.userData.plan_id
                      ).is_free))) ||
                (nextProps.userData.current_step < 6 &&
                  !nextProps.userData.is_referred &&
                  nextProps.userData.use_payment &&
                  (nextProps.userData.plan_id
                    ? memberships.find(
                        (membership) =>
                          membership.id === nextProps.userData.plan_id
                      ) &&
                      !memberships.find(
                        (membership) =>
                          membership.id === nextProps.userData.plan_id
                      ).is_free
                    : true))
              ) {
                if (history.length > 1) {
                  sendAnalyticEvent(nextProps.userData.current_step);
                } else {
                  history.replace(
                    "/application/sign-in" +
                      (ReferralHash.hash
                        ? "?referral_hash=" + ReferralHash.hash
                        : "")
                  );
                }
              }
              break;
            case "congrats":
              if (
                nextProps.userData.current_step < 7 ||
                nextProps.userData.is_active
              ) {
                sendAnalyticEvent(nextProps.userData.current_step);
                console.log("debug");

                history.replace(
                  "/application/reasons-to-join" +
                    (ReferralHash.hash
                      ? "?referral_hash=" + ReferralHash.hash
                      : "")
                );
              } else {
                fbq("track", "CompleteRegistration"); // eslint-disable-line
              }
              break;
            case "congratulations":
              if (
                nextProps.userData.current_step < 7 ||
                nextProps.userData.is_active
              ) {
                sendAnalyticEvent(nextProps.userData.current_step);
                console.log("debug");

                history.replace(
                  "/application/reasons-to-join" +
                    (ReferralHash.hash
                      ? "?referral_hash=" + ReferralHash.hash
                      : "")
                );
              } else {
                fbq("track", "Purchase"); // eslint-disable-line
              }
              break;
            case "download":
              if (
                nextProps.userData.current_step < 7 ||
                !nextProps.userData.is_active
              ) {
                sendAnalyticEvent(nextProps.userData.current_step);
                console.log("debug");

                history.replace(
                  "/application/reasons-to-join" +
                    (ReferralHash.hash
                      ? "?referral_hash=" + ReferralHash.hash
                      : "")
                );
              } else {
                fbq("track", "ViewContent"); // eslint-disable-line
              }
              break;
          }
        }
      }
    }

    if (
      nextProps.responseCodes &&
      JSON.stringify(nextProps.responseCodes) !== JSON.stringify(responseCodes)
    ) {
      (nextProps.responseCodes.createPassword ||
        nextProps.responseCodes.changeEmail) &&
        history.replace(
          "/application/sign-in" +
            (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
        );

      if (nextProps.responseCodes.reasons) {
        userData.current_step < 1 && incrementStep(1);

        history.replace(
          "/application/details" +
            (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
        );
      }

      if (nextProps.responseCodes.details) {
        userData.current_step < 2 && incrementStep(2);

        history.replace(
          "/application/interests" +
            (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
        );
      }

      if (nextProps.responseCodes.interests) {
        userData.current_step < 3 && incrementStep(3);

        history.replace(
          "/application/about" +
            (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
        );
      }

      if (nextProps.responseCodes.about && !userData.is_referred) {
        userData.current_step < 4 && incrementStep(4);

        if (userData.use_payment) {
          history.replace(
            "/application/memberships" +
              (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
          );
        } else {
          if (userData.is_verified_email && userData.is_terms_accepted) {
            if (
              userData.use_payment &&
              memberships.find(
                (membership) => membership.id === userData.plan_id
              ) &&
              !memberships.find(
                (membership) => membership.id === userData.plan_id
              ).is_free
            ) {
              history.replace(
                "/application/congratulations" +
                  (ReferralHash.hash
                    ? "?referral_hash=" + ReferralHash.hash
                    : "")
              );
            } else {
              history.replace(
                "/application/congrats" +
                  (ReferralHash.hash
                    ? "?referral_hash=" + ReferralHash.hash
                    : "")
              );
            }
          } else {
            history.replace(
              "/application/email-confirmation" +
                (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
            );
          }
        }
      } else if (nextProps.responseCodes.about && userData.is_referred) {
        userData.current_step < 5 && incrementStep(5);

        if (userData.is_verified_email && userData.is_terms_accepted) {
          if (
            userData.use_payment &&
            memberships.find(
              (membership) => membership.id === userData.plan_id
            ) &&
            !memberships.find(
              (membership) => membership.id === userData.plan_id
            ).is_free
          ) {
            history.replace(
              "/application/congratulations" +
                (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
            );
          } else {
            history.replace(
              "/application/congrats" +
                (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
            );
          }
        } else {
          history.replace(
            "/application/email-confirmation" +
              (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
          );
        }
      }

      if (memberships && userData && nextProps.responseCodes.memberships) {
        userData.current_step < 5 && incrementStep(5);

        if (
          !userData.is_referred &&
          userData.use_payment &&
          memberships.find(
            (membership) => membership.id === userData.plan_id
          ) &&
          !memberships.find((membership) => membership.id === userData.plan_id)
            .is_free
        ) {
          history.replace(
            "/application/payment" +
              (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
          );
        } else if (
          userData.is_referred ||
          !userData.use_payment ||
          (memberships.find(
            (membership) => membership.id === userData.plan_id
          ) &&
            memberships.find((membership) => membership.id === userData.plan_id)
              .is_free)
        ) {
          if (userData.is_verified_email && userData.is_terms_accepted) {
            if (
              userData.use_payment &&
              memberships.find(
                (membership) => membership.id === userData.plan_id
              ) &&
              !memberships.find(
                (membership) => membership.id === userData.plan_id
              ).is_free
            ) {
              history.replace(
                "/application/congratulations" +
                  (ReferralHash.hash
                    ? "?referral_hash=" + ReferralHash.hash
                    : "")
              );
            } else {
              history.replace(
                "/application/congrats" +
                  (ReferralHash.hash
                    ? "?referral_hash=" + ReferralHash.hash
                    : "")
              );
            }
          } else {
            history.replace(
              "/application/email-confirmation" +
                (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
            );
          }
        }
      }

      if (
        nextProps.responseCodes.creditCard ||
        nextProps.responseCodes.billingAddress
      ) {
        userData.current_step < 6 && incrementStep(6);

        if (userData.is_verified_email && userData.is_terms_accepted) {
          if (
            userData.use_payment &&
            memberships.find(
              (membership) => membership.id === userData.plan_id
            ) &&
            !memberships.find(
              (membership) => membership.id === userData.plan_id
            ).is_free
          ) {
            history.replace(
              "/application/congratulations" +
                (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
            );
          } else {
            history.replace(
              "/application/congrats" +
                (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
            );
          }
        } else {
          history.replace(
            "/application/email-confirmation" +
              (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
          );
        }
      }

      if (
        memberships &&
        userData &&
        userData.first_name &&
        nextProps.responseCodes.termsAndConditions
      ) {
        userData.current_step < 7 && incrementStep(7);

        if (
          userData.use_payment &&
          memberships.find(
            (membership) => membership.id === userData.plan_id
          ) &&
          !memberships.find((membership) => membership.id === userData.plan_id)
            .is_free
        ) {
          history.replace(
            "/application/congratulations" +
              (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
          );
        } else {
          history.replace(
            "/application/congrats" +
              (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
          );
        }
      }
    }

    nextProps.errorCodes &&
      JSON.stringify(nextProps.errorCodes) !== JSON.stringify(errorCodes) &&
      (nextProps.errorCodes.termsAndConditions ||
        nextProps.errorCodes.createPassword ||
        nextProps.errorCodes.changeEmail ||
        nextProps.errorCodes.refreshToken ||
        nextProps.errorCodes.settings ||
        nextProps.errorCodes.userData ||
        nextProps.errorCodes.incrementStep ||
        nextProps.errorCodes.reasons ||
        (nextProps.errorCodes.details &&
          !nextProps.errorCodes.details.toString().startsWith("4")) ||
        (nextProps.errorCodes.about &&
          !nextProps.errorCodes.about.toString().startsWith("4")) ||
        nextProps.errorCodes.interests ||
        nextProps.errorCodes.memberships ||
        (nextProps.errorCodes.creditCard &&
          !nextProps.errorCodes.creditCard.toString().startsWith("4")) ||
        (nextProps.errorCodes.billingAddress &&
          !nextProps.errorCodes.billingAddress.toString().startsWith("4")) ||
        nextProps.errorCodes.deletion ||
        (nextProps.errorCodes.verificationMessage &&
          !nextProps.errorCodes.verificationMessage
            .toString()
            .startsWith("4"))) &&
      this.signOut();
  }

  setAuthentication(token) {
    const { refreshToken, getUserData } = this.props;

    setTimeout(() => refreshToken(token), token.expiresIn);

    this.secureLocalStorage.set("token", { data: token });

    axios.defaults.headers.common["Authorization"] = `Bearer ${token.access}`;

    getUserData(token);
  }

  signOut() {
    const {
      deleteData,
      signOut,
      history,
      match: {
        params: { currentStep },
      },
    } = this.props;

    this.secureLocalStorage.removeAll();

    delete axios.defaults.headers.common["Authorization"];

    deleteData();
    signOut();

    currentStep !== "reset-password" &&
      currentStep !== "create-password" &&
      history.replace(
        "/application/sign-in" +
          (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
      );
  }

  render() {
    const {
      responseCodes,
      errorCodes,
      errorFields,
      match: {
        params: { currentStep, urlUserId, urlEmailId },
      },
      location: { search },
      history,
      userData,
      memberships,
    } = this.props;

    return (
      <ApplicationView
        responseCodes={responseCodes}
        errorCodes={errorCodes}
        errorFields={errorFields}
        currentStep={currentStep}
        urlUserId={urlUserId}
        urlEmailId={urlEmailId}
        urlParameters={search}
        history={history}
        userData={userData}
        memberships={memberships}
        signOut={this.signOut}
      />
    );
  }
}

Application.propTypes = {
  userData: PropTypes.object,
  history: PropTypes.object,
  responseCodes: PropTypes.object,
  errorCodes: PropTypes.object,
  token: PropTypes.object,
  memberships: PropTypes.array,
  location: PropTypes.object,
  match: PropTypes.object,
  errorFields: PropTypes.object,
  signOut: PropTypes.func,
  deleteData: PropTypes.func,
  getUserData: PropTypes.func,
  refreshToken: PropTypes.func,
  incrementStep: PropTypes.func,
  restoreAuthentication: PropTypes.func,
  incrementReferral: PropTypes.func,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Application));
